import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../../assets/springwater/movie.mp4';
const _hoisted_1 = {
  class: "iconButton"
};
const _hoisted_2 = {
  key: 0,
  class: "videoBg"
};
const _hoisted_3 = {
  key: 1,
  class: "videoGif"
};
const _hoisted_4 = {
  key: 2,
  class: "logo"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  id: "cont3dBgc",
  class: "cont3dlist"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  id: "cont3d",
  class: "cont3dlist"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  id: "cont3d",
  class: "cont3dlist"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  id: "cont3d",
  class: "cont3dlist"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`springWaterList ${$data.pageType || ''}`)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "icon-list",
    onClick: _cache[0] || (_cache[0] = $event => $options.toList())
  }), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "icon-apoints"
  }, null, -1))]), !$options.isMobile && !$data.pageType ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [_createElementVNode("video", {
    src: _imports_0,
    autoplay: "autoplay",
    muted: "",
    loop: "loop"
  }, null, -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_3)), $data.config.logo ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.config.logo
  }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(`cont3d ${$options.isMobile ? 'h5' : ''}`)
  }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, val => {
    return _createElementVNode("div", {
      class: _normalizeClass(`maopao pao${val}`)
    }, null, 2);
  }), 64)), _withDirectives(_createElementVNode("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datasAll[0], (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`firstBgData Item3dDelay toTop${index}`)
    }, [_createElementVNode("div", null, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_7)])], 2);
  }), 256))], 512), [[_vShow, $data.showFirstBg]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datasAll, (list, listIndex) => {
    return _openBlock(), _createElementBlock("ul", _hoisted_8, [$data.showBgIndex.indexOf(listIndex) > -1 ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList(list, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(`Item3dDelay firstBgData toTop${index} listData`),
        onClick: $event => $options.toDetail(item)
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: item.img
      }, null, 8, _hoisted_10)])], 10, _hoisted_9);
    }), 256)) : _createCommentVNode("", true)]);
  }), 256)), _withDirectives(_createElementVNode("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datasAll[0], (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(`Item3dDelay firstData toTop${index}`),
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("div", null, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_13)])], 10, _hoisted_12);
  }), 256))], 512), [[_vShow, $data.showFirst]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datasAll, (list, listIndex) => {
    return _openBlock(), _createElementBlock("ul", _hoisted_14, [$data.showIndex.indexOf(listIndex) > -1 ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList(list, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(`Item3dDelay firstData toTop${index} listData`),
        onClick: $event => $options.toDetail(item)
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: item.img
      }, null, 8, _hoisted_16)])], 10, _hoisted_15);
    }), 256)) : _createCommentVNode("", true)]);
  }), 256))], 2)], 2);
}